import { render, staticRenderFns } from "./AdAccountDropdown.vue?vue&type=template&id=70b0b52e&scoped=true&"
import script from "./AdAccountDropdown.vue?vue&type=script&lang=ts&"
export * from "./AdAccountDropdown.vue?vue&type=script&lang=ts&"
import style0 from "./AdAccountDropdown.vue?vue&type=style&index=0&id=70b0b52e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b0b52e",
  null
  
)

export default component.exports